module.exports = __webpack_public_path__ + "img/mtap-logo.ea9fcd33.svg";